/* eslint-disable jsx-a11y/iframe-has-title */
import Banner from "../../sections/common/banner";
import { publicUrlFor } from "../../../globals/constants";
import { data as dataEs } from "../../../globals/data/es/contact-us";
import { data as dataEn } from "../../../globals/data/en/contact-us";
import { data as dataCn } from "../../../globals/data/zh/contact-us";
import { useLangagesStore } from "../../../context/langages";

export default function ContactPage() {
    const { language } = useLangagesStore();
    const data = language === "en" ? dataEn : language === "cn" ? dataCn : dataEs;
    return (
        <>
            <Banner _data={data.banner} />
            
            <div className="section-full p-t120 p-b120">
                <div className="section-content">
                    <div className="container">
                        <div className="gmap-outline mb-5">
                            <div className="google-map">
                                <div style={{ width: '100%' }}>
                                    <iframe
                                        title="Asemarinsa location map"
                                        height={460}
                                        loading="lazy"
                                        style={{ width: '100%', border: 0, filter: 'none', WebkitFilter: 'none', opacity: 1 }}
                                        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d985.2452484420079!2d-79.52871371357978!3d8.973895475290458!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sAv.%20Balboa%2C%20Torre%20BAC%2C%20piso%2013%2C%20oficina%202%20Panam%C3%A1%2C%20Panama%20City%2C%20Panama%200831!5e0!3m2!1ses!2sve!4v1760496845427!5m2!1ses!2sve"
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="contact-one">
                            {/* TITLE START*/}
                            <div className="section-head left wt-small-separator-outer">
                                <h2 className="wt-title m-b30">{data.banner.sendMessage}</h2>
                            </div>
                            {/* TITLE END*/}
                            {/* CONTACT FORM*/}
                            <div className="contact-one-inner  site-bg-sky-blue-light">
                                <div className="row">
                                    <div className="col-lg-8 col-md-12">
                                        <div className="contact-form-outer">
                                            <form className="cons-contact-form" method="post" action="form-handler2.php">
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="form-group mb-3">
                                                            <input name="username" type="text" required className="form-control" placeholder={data.banner.name} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <input name="email" type="text" className="form-control" required placeholder={data.banner.email} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <input name="phone" type="text" className="form-control" required placeholder={data.banner.phone} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="form-group mb-3">
                                                            <input name="subject" type="text" className="form-control" required placeholder={data.banner.subject} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12">
                                                        <div className="form-group mb-3">
                                                            <textarea name="message" className="form-control" rows={3} placeholder={data.banner.message} defaultValue={""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <button type="submit" className="btn-half site-button"><span>{data.banner.submitNow}</span><em /></button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-12">
                                        <div className="contact-info  site-bg-dark bg-no-repeat bg-bottom-left" style={{ backgroundImage: `url(${publicUrlFor('/assets/images/background/contact-bg.png')})` }}>
                                            {/* TITLE START*/}
                                            <div className="section-head-small white mb-4">
                                                <h3 className="wt-title">{data.banner.contactUs}</h3>
                                            </div>
                                            {/* TITLE END*/}
                                            <div className="contact-info-section">
                                                <div className="c-info-column">
                                                    <div className="c-info-icon fa fa-map-marker"><span /></div>
                                                    <p>Av. Balboa, Torre BAC, piso 13, oficina 2 Panamá, Panama City, Panama 0831</p>
                                                </div>
                                                <div className="c-info-column">
                                                    <div className="c-info-icon fa fa-mobile-phone custome-size"><span /></div>
                                                    <p><a href="tel:+50763899494">+507 6389-9494</a></p>
                                                </div>
                                                <div className="c-info-column">
                                                    <div className="c-info-icon fa fa-envelope-o"><span /></div>
                                                    <p>operaciones@asemarinsa.com</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
